import { render } from "./ShippingModal.vue?vue&type=template&id=1886c35e&scoped=true"
import script from "./ShippingModal.vue?vue&type=script&lang=js"
export * from "./ShippingModal.vue?vue&type=script&lang=js"

import "./ShippingModal.vue?vue&type=style&index=0&id=1886c35e&scoped=true&lang=css"
import "./ShippingModal.vue?vue&type=style&index=1&id=1886c35e&lang=css"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1886c35e"]])

export default __exports__